// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {injectIntl, intlShape} from 'react-intl';

const TranslatedInput = ({intl, placeholder, value, ...props}) => {

    const {formatMessage} = intl;

    const translatedText = formatMessage({id: placeholder});

    return (
        <input
            {...props}
            placeholder={translatedText}
            value={value ? value : ''}
        />
    );

};

TranslatedInput.displayName = 'TranslatedInput';
TranslatedInput.propTypes = {
    intl: intlShape,
    placeholder: PropTypes.string,
    value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ])
};

export default injectIntl(TranslatedInput);



// WEBPACK FOOTER //
// ./src/shared/components/translated-input.js